// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-f215c9ee]{border-collapse:collapse}table[data-v-f215c9ee],td[data-v-f215c9ee],th[data-v-f215c9ee]{border:.5px solid #000}@media print{div.footer[data-v-f215c9ee]{bottom:0;margin-top:10px;position:fixed}div.footer p[data-v-f215c9ee]{text-align:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
